import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import TitumAuthorization from "./@titum/core/TitumAuthorization";
import AppContext from "./AppContext";
import Layout from "./titum-layouts/Layout";
import store from "./Redux/store";
import routes from "./titum-configs/routesConfig";
import { Auth } from "./auth";
import { ChannelProvider } from "ably/react";

import "./App.css";
import { ConnectionState } from "ConnectionState";
import { CHANNEL_NAMES } from "Components/Constants/ChannelNames";
import PreventPullToRefresh from "PreventPullToRefresh";

function App() {
  var pjson = require("../package.json");

  return (
    <ChannelProvider channelName={CHANNEL_NAMES.CREATE_KOT}>
      <ChannelProvider channelName={CHANNEL_NAMES.KOT_PARTIALLY_PROCESSING}>
        <ChannelProvider channelName={CHANNEL_NAMES.KOT_COMPLETE}>
          <ChannelProvider channelName={CHANNEL_NAMES.KOT_REVERSAL}>
            <AppContext.Provider
              value={{
                routes,
              }}
            >
              <Provider store={store}>
                <Auth>
                  <BrowserRouter basename={pjson.url}>
                    <TitumAuthorization>
                      <PreventPullToRefresh>
                        <Layout />
                        <ConnectionState />
                      </PreventPullToRefresh>
                    </TitumAuthorization>
                  </BrowserRouter>
                </Auth>
              </Provider>
            </AppContext.Provider>
          </ChannelProvider>
        </ChannelProvider>
      </ChannelProvider>
    </ChannelProvider>
  );
}

export default App;
